import { establishmentService } from '../../services/establishment';
import { makeMutation } from '../utils/makeMutation';

export const useGetEstablishmentByToken = makeMutation({
  mutationKey: ['getEstablishmentByToken'],
  mutationFn: (token?: string) => {
    return establishmentService.getEstablishmentByToken(token);
  },
});
